import colors from '../assets/colors';

export const STORE_TEMPLATE_ID = 'screen_to_store';

export const isStoreTemplate = template =>
  template?.id === STORE_TEMPLATE_ID || template?.displayName === 'Screen to Store';

export const isAttributionTemplateAvailable = (template, activeFeatures) =>
  isStoreTemplate(template)
    ? activeFeatures?.includes('SCREEN_TO_STORE')
    : activeFeatures?.includes('WEB_ANALYTICS');

export const storeViewIds = {
  exposedDevices: 'store_exposed_devices',
  storeVisits: 'store_visits',
  conversionRate: 'store_conversion_rate',
  attributedVisitors: 'store_attributed_visitors',
  exposedVsVisits: 'store_exposures_vs_visits',
  topSites: 'store_exposure_top_sites',
  topStores: 'store_attribution_top_stores',
  map: 'store_attribution_map'
};

export const storeTemplate = {
  id: STORE_TEMPLATE_ID,
  displayName: 'Screen to Store',
  collection: 'ATTRIBUTION',
  compatibleDatasources: ['MOBILE_M'],
  enabled: true,
  legacyTable: '',
  table: '',
  isCms: false,
  cmsId: '',
  headers: '',
  rows: [
    { widgets: [
      { id: 'store-exposed-devices', url: 'store-exposed-devices.json' },
      { id: 'store-visits', url: 'store-visits.json' },
      { id: 'store-conversion-rate', url: 'store-conversion-rate.json' }
    ] },
    { widgets: [{ id: 'store-exposed-vs-visits', url: 'store-exposed-vs-visits.json' }] },
    { widgets: [
      { id: 'store-top-sites', url: 'store-top-sites.json' },
      { id: 'store-most-visited-stores', url: 'store-most-visited-stores.json' }
    ] },
    { widgets: [{ id: 'store-attribution-map', url: 'store-attribution-map.json' }] }
  ]
};

export const storeCards = [
  { id: 'store-exposed-devices', title: 'Exposed Devices', key: 'exposedDevices', format: 'integer' },
  { id: 'store-visits', title: 'Store Visits', key: 'storeVisits', format: 'integer' },
  { id: 'store-conversion-rate', title: 'Conversion Rate', key: 'conversionRate', format: 'float', unit: '%' }
];

export const storeViews = ['exposedDevices', 'storeVisits', 'conversionRate', 'attributedVisitors', 'exposedVsVisits',
  'topSites', 'topStores', 'map'];

export const storeWidgetInfo = {
  'store-exposed-devices': 'Distinct mobile devices exposed at campaign sites during the selected period.',
  'store-visits': 'Distinct mobile devices observed at target stores, including unattributed visitors.',
  'store-conversion-rate': 'Attributed visitors divided by exposed devices, using each target site attribution window.',
  'store-exposed-vs-visits': 'Daily exposed devices and target-store visitors.',
  'store-top-sites': 'Campaign sites ranked by distinct exposed devices.',
  'store-most-visited-stores': 'Target stores ranked by distinct attributed visitors.'
};


export const storeWidgets = {
  'store-exposed-vs-visits': { title: 'Exposed Devices vs. Store Visits', display: 'line',
    config: { colors: [colors.mainPallet[0], colors.mainPallet[3]], height: 260 } },
  'store-top-sites': { title: 'Top Performing Sites', display: 'stats-list',
    config: { height: 270 }, plotOptions: { displayBars: true } },
  'store-most-visited-stores': { title: 'Most Visited Stores', display: 'stats-list',
    config: { height: 270 }, plotOptions: { displayBars: true } }
};
